// Hand-duplicated from shared/languages.js since frontend/src can't import outside src/
// under CRA's ModuleScopePlugin (see lib/languageSpeechConfig.js for the same pattern).
export const SUPPORTED_LANGUAGES = ['English', 'Spanish', 'Mandarin', 'Japanese', 'French', 'German', 'Italian', 'Korean', 'Portuguese', 'Arabic'];

// Each language's autonym (name in its own script), shown in the Native Language picker
// regardless of the current UI language — e.g. Mandarin always reads "中文", never "Mandarin".
export const LANGUAGE_SELF_NAMES = {
  English: 'English',
  Spanish: 'Español',
  Mandarin: '中文',
  Japanese: '日本語',
  French: 'Français',
  German: 'Deutsch',
  Italian: 'Italiano',
  Korean: '한국어',
  Portuguese: 'Português',
  Arabic: 'العربية',
};
